export const defaultSchedule = {
  0: { active: false },
  1: { start: 540, end: 1020, active: true },
  2: { start: 540, end: 1020, active: true },
  3: { start: 540, end: 1020, active: true },
  4: { start: 540, end: 1020, active: true },
  5: { start: 540, end: 1020, active: true },
  6: { active: false },
};
